<template>
  <div>
    <div class="wrapper settings">
      <div class="i-css-left">
        <div class="form-group">
          <label>{{ LANG.template }}:</label>
          <select v-model="selectedTemplate" name="view" class="imp_select form-control i-action-set-view">
            <option v-for="(template, idx) in this.templates" :key="idx" :value="template.value">
              {{ template.display }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ LANG.mode }}:</label>
          <select v-model="selectedMode" name="source" class="imp_select form-control">
            <option value="source">Sourcecode</option>
            <option value="WYSIWYG">HTML</option>
          </select>
        </div>
      </div>

      <div class="i-css-right">
        <div class="form-group">
          <label>{{ LANG.versionFilter }}:</label>
          <select v-model="selectedFilter" name="filter" class="imp_select form-control i-action-filter">
            <option v-for="(filter, idx) in filters" :key="idx" :value="filter.value">
              {{ filter.display }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="">{{ LANG.count }}:</label>
          <select v-model="selectedCount" name="count" class="imp_select form-control i-action-set-count i-css-left">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
        </div>
        <div class="button_container">
          <a :href="slideshowUri" target="_blank"  :disabled="buttonDisabled" class="i-button btn i-primary-btn i-action-open-slideshow" title="Examine differences">
            <i class="fa5 fas fa-desktop"></i>
            <span class="i-btn-label">{{ LANG.openSlideshow }}</span>
          </a>
        </div>
      </div>
    </div>

    <table class="filelist" cellspacing="0" cellpadding="0" width="100%">
      <thead>
        <tr>
          <th>Date</th>
          <th width="50">Status</th>
          <th width="50">From</th>
          <th width="50">To</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(version, idx) in versions" :key="idx">
          <td>
            <a :href="previewUrl(nodeId, version.arch_id)" target="_blank" class="block_link">
              {{ version.date }}
            </a>
          </td>
          <td>
            {{ getStatusText(version.status) }}
          </td>
          <td>
             <label class="i-material-radio">
              <input
                type="radio"
                name="__imperia_archid_old"
                v-bind:value="version.arch_id || 'workflow'"
                v-model="oldArchId"
              />
              <span></span>
            </label>
          </td>
          <td>
            <label class="i-material-radio">
              <input
                type="radio"
                name="__imperia_archid_new"
                v-bind:value="version.arch_id || 'workflow'"
                v-model="newArchId"
              />
              <span></span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import fetchService from '@/utils/model/fetch_service';

import globals from '@/globals';

const { uri } = globals.I.Util;

export default defineComponent({
  props: ['nodeId'],
  data: () => ({
    info: Object,
    selectedCount: 15,
    selectedFilter: '',
    selectedTemplate: '',
    selectedMode: 'WYSIWYG',
    oldArchId: '',
    newArchId: '',
  }),
  async created() {
    const params = {
      __imperia_node_id: this.nodeId,
    };
    const response = await fetchService.GetData('docbrowser_differences', params);

    this.info = response.data;

    this.selectedFilter = this.info.diff.filter.selected || '';
    this.selectedTemplate = this.info.diff.templates.selected || '';
  },
  computed: {
    ...mapState(['LANG']),
    templates() {
      if (!this.info.diff) return [];
      return this.info.diff.templates.options;
    },
    filters() {
      if (!this.info.diff) return [];
      return this.info.diff.filter.options;
    },
    versions() {
      if (!this.info.diff) return '';

      // TODO Rework the filter logic, it is not obvious how it should work
      return this.info.diff.versions.filter((version) => {
        if (this.selectedFilter === '') return true;
        if (this.selectedFilter === 'MY') return true;
        if (this.selectedFilter === 'FINISHED' && (version.status === undefined || version.status === 1)) return true;
        return false;
      }).slice(0, this.selectedCount);
    },
    slideshowUri() {
      const params = {
        __imperia_node_id: this.nodeId,
        view: this.selectedTemplate,
        source: this.selectedMode,
        filter: this.selectedFilter,
        count: this.selectedCount,
        __imperia_archid_new: this.newArchId,
        __imperia_archid_old: this.oldArchId,
      };

      return uri('/document/diff_display', params);
    },
    buttonDisabled() {
      return this.oldArchId && this.newArchId && this.oldArchId === this.newArchId;
    },
  },
  methods: {
    getStatusText(status) {
      if (status === undefined) return '[Workflow]';
      if (status) return '[Finished]';
      return '';
    },
    previewUrl(nodeId, archId) {
      return uri(`/document/preview?__imperia_node_id=${nodeId}&__imperia_arch_id=${archId}`);
    },
  },
});
</script>

<style scoped lang='scss'>
a[disabled] {
  pointer-events: none;
}

table {
  tr {
    td {
      text-align: left;
    }
  }
}
</style>
